import React from 'react';
import { Route, Routes } from 'react-router-dom';

import HomePage from '../pages/HomePage';
import EventsPage from '../pages/EventsPage';
import EventDetailPage from '../pages/EventDetailPage';
import SessionsPage from '../pages/SessionsPage';
import SessionDetailPage from '../pages/SessionDetailPage';
import TranscriptEditPage from '../pages/TranscriptEditPage';
import ReportEditPage from '../pages/ReportEditPage';
import UploadPage from '../pages/UploadPage';
import PromptTemplatesPage from '../pages/PromptTemplatesPage';
import LoginPage from '../pages/LoginPage';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/events" element={<EventsPage />} />
      <Route path="/events/:id" element={<EventDetailPage />} />
      <Route path="/sessions" element={<SessionsPage />} />
      <Route path="/sessions/:id" element={<SessionDetailPage />} />
      <Route path="/sessions/:id/edit" element={<TranscriptEditPage />} />
      <Route path="/sessions/:id/report/edit" element={<ReportEditPage />} />
      <Route path="/upload" element={<UploadPage />} />
      <Route path="/prompt-templates" element={<PromptTemplatesPage />} />
      <Route path="/login" element={<LoginPage />} />
    </Routes>
  );
}
